export default /*@ngInject*/ function ($http, errorsDataService) {

    const service = {
        analyzeLicenseImpact,
        analyzeLicenseImpactWithRequest,
        getAadSkuMappings,
        updateAadSkuMapping,
        getPrepaidUnits
    };

    return service;

    async function analyzeLicenseImpact(requestData) {
        try {
            return await $http({
                method: 'POST',
                url: `${apiUrl}api/identitymanager/ax7/licenseanalysis`,
                data: requestData
            });
        } catch (err) {
            showError(err);
            throw err;
        }
    }

    async function analyzeLicenseImpactWithRequest(requestData) {
        try {
            return await $http({
                method: 'POST',
                url: `${apiUrl}api/identitymanager/ax7/licenseanalysis/withrequest`,
                data: requestData
            });
        } catch (err) {
            showError(err);
            throw err;
        }
    }

    async function getAadSkuMappings() {
        try {
            return await $http({
                method: 'GET',
                url: `${apiUrl}api/assure/ax7/license/skus/aadmapping`
            });
        } catch (err) {
            showError(err);
            throw err;
        }
    }

    async function updateAadSkuMapping(skuId, aadSkuId) {
        try {
            return await $http({
                method: 'PUT',
                url: `${apiUrl}api/assure/ax7/license/skus/${skuId}/aadmapping`,
                data: { aadSkuId: aadSkuId }
            });
        } catch (err) {
            showError(err);
            throw err;
        }
    }

    function showError(err) {
        errorsDataService.catch(err);
    }

    function getPrepaidUnits(skuPartNumber) {
        return $http({
            method: 'GET',
            url: `${apiUrl}api/identitymanager/aad/licenses/${encodeURIComponent(skuPartNumber)}/prepaidunits`
        });
    }
}
